$(document).ready(function () {
  /**
   * Main Nav
   */
  var mainNav = $(".js-main-nav")
  var burgerBtn = $(".js-burger-btn")

  // Mobile menu button
  burgerBtn.on("click", function () {
    mainNav.toggleClass("open")
  })
  /**
   * END - Main Nav
   */

  /**
   *  Lazy Load Imagaes
   */

  function loadImages() {
    $("[data-img-bg]").each(function () {
      var el = $(this)
      var src = $(this).data("img-bg")
      if (src) {
        var img = new Image()
        img.style.display = "none"
        img.src = src
        el.css("background-image", "url(" + src + ")")
        img.onload = function () {
          el.addClass("loaded")
        }
      }
    })
    $("[data-img-src]").each(function () {
      var el = $(this)
      var src = $(this).data("img-src")
      if (src) {
        var img = new Image()
        img.style.display = "none"
        img.src = src
        el.attr("src", src)
        img.onload = function () {
          el.addClass("loaded")
        }
      }
    })
  }
  loadImages()
  /**
   *  END - Lazy Load Imagaes
   */
})

$(window).load(function () {
  /**
   * Start Scroll Trigger
   */

  function animateFrom(elem, direction) {
    direction = direction || 1
    var x = 0,
      y = direction * 100
    if (elem.classList.contains("gs_reveal_fromLeft")) {
      x = -100
      y = 0
    } else if (elem.classList.contains("gs_reveal_fromRight")) {
      x = 100
      y = 0
    }
    elem.style.transform = "translate(" + x + "px, " + y + "px)"
    elem.style.opacity = "0"
    gsap.fromTo(
      elem,
      { x: x, y: y, autoAlpha: 0 },
      {
        duration: 1.25,
        x: 0,
        y: 0,
        autoAlpha: 1,
        ease: "expo",
        overwrite: "auto",
      }
    )
  }

  function hide(elem) {
    gsap.set(elem, { autoAlpha: 0 })
  }

  gsap.registerPlugin(ScrollTrigger)

  // Slide-in reveals
  gsap.utils.toArray(".gs_reveal").forEach(function (elem) {
    hide(elem) // assure that the element is hidden when scrolled into view

    ScrollTrigger.create({
      trigger: elem,
      onEnter: function () {
        animateFrom(elem)
      },
      onEnterBack: function () {
        // animateFrom(elem, -1)
      },
      onLeaveBack: function () {
        hide(elem)
      }, // assure that the element is hidden when scrolled into view
    })
  })

  // Parallax
  gsap.utils.toArray(".gs_header_parallax").forEach(function (elem) {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: elem,
          start: "top top",
          end: "bottom top",
          scrub: true,
        },
      })
      .to(elem, { yPercent: 20, ease: "none" }, 0)
  })

  // 3/4 SVG icons animation
  gsap.utils.toArray(".js-three-fourths-svg").forEach(function (elem) {
    ScrollTrigger.create({
      trigger: elem,
      start: "bottom 90%",
      onEnter: function () {
        elem.setAttribute("class", "js-three-fourths-svg active")
      },
    })
  })

  // Logo animation
  gsap.utils.toArray(".js-logo-animate").forEach(function (elem) {
    ScrollTrigger.create({
      trigger: elem,
      start: "bottom 100%",
      onEnter: function () {
        elem.classList.remove("js-logo-animate")
      },
    })
  })

  gsap.utils.toArray(".js-logo-stroke-animate").forEach(function (elem) {
    ScrollTrigger.create({
      trigger: elem,
      start: "bottom 100%",
      onEnter: function () {
        elem.classList.add("active")
      },
    })
  })

  // Stats animation
  gsap.utils.toArray(".js-animate-stat").forEach(function (elem) {
    const number = $(elem).find(".number")
    const num = $(elem).find(".number").data("num")
    const obj = { number: 0 }

    ScrollTrigger.create({
      trigger: elem,
      start: "top bottom",
      onEnter: function () {
        gsap.set(elem, { scale: 0 })
        gsap.fromTo(elem, 2, { scaleX: 0, scaleY: 0 }, { scaleX: 1, scaleY: 1 })
        gsap.fromTo(
          obj,
          3,
          { number: 0 },
          {
            number: num,
            onUpdate: () => {
              number.html(Math.round(obj.number))
            },
          }
        )
      },
      onLeaveBack: function () {
        gsap.set(elem, { scale: 0 })
      },
    })
  })

  /**
   * Brands Menu
   */
  if ($(".js-filter-menu").length) {
    $(".js-filter-menu").each((index, value) => {
      var button = $(value).find("span")
      button.on("click", (e) => {
        var windowWidth = window.innerWidth

        if (windowWidth <= 768) {
          var el = $(e.currentTarget).parent().find(".dropdown"),
            curHeight = el.height(),
            autoHeight = el.css("height", "auto").height()

          button.toggleClass("open")

          if (button.hasClass("open")) {
            el.height(curHeight).animate({ height: autoHeight }, 500)
          } else {
            el.height(curHeight).animate({ height: 0 }, 500)
          }
        }
      })
    })
  }

  /**
   * Filters
   */
  if ($(".page-template-page-brands").length) {
    var brands_well = $(".js-brands-well")
    var filtered_brands = $(".js-filtered-brands")
    var load_more_btn = $(".js-load-more-btn")

    var checked_arr = []
    var num_per_page = 20
    var page_index = 1

    filtered_brands.find(".content-block").removeClass("visible")
    filtered_brands.find(".content-block").find(".logo").empty()
    filtered_brands.find(".content-block").find(".image").empty()

    load_more_btn.on("click", function () {
      window.loadMoreBrands()
    })

    // called when selecting a filter
    window.compileFilters = function () {
      // go back to page 1
      page_index = 1
      // reset checked array
      checked_arr = []
      // put everything back into the brands well
      filtered_brands.find(".content-block").removeClass("visible")
      filtered_brands.find(".content-block").find(".logo").empty()
      filtered_brands.find(".content-block").find(".image").empty()
      filtered_brands.contents().prependTo(brands_well)
      // show load more button
      load_more_btn.removeClass("hide")

      // get checked categories
      var checked_cats = $(".js-category-dropdown").find(
        "input[type=checkbox]:checked"
      )
      // push checked cats into checked array
      $.each(checked_cats, function (index, value) {
        checked_arr.push("." + $(value).val())
      })

      // get checked brands
      var checked_brands = $(".js-brands-dropdown").find(
        "input[type=checkbox]:checked"
      )
      // push checked brands into checked array
      $.each(checked_brands, function (index, value) {
        checked_arr.push("." + $(value).val())
      })

      // show filtered contents
      if (checked_arr.length) {
        console.log(checked_arr)
        var filtered = $(".js-brands-well").find(checked_arr.toString())
        filtered.prependTo(filtered_brands)
      } else {
        // no filters, so dump everything back into filtered_brands
        brands_well.contents().prependTo(filtered_brands)
      }

      window.showFiltered()
    }

    // show filtered
    window.showFiltered = function () {
      // first sort them by 'data-sid'
      var result = filtered_brands
        .find(".content-block")
        .sort(function (a, b) {
          var contentA = parseInt($(a).data("sid"))
          var contentB = parseInt($(b).data("sid"))
          return contentA < contentB ? -1 : contentA > contentB ? 1 : 0
        })
        .appendTo(filtered_brands)

      // show them
      for (var i = 0; i < page_index * num_per_page; i++) {
        var filtered_brand = filtered_brands.find(".content-block").eq(i)
        if (filtered_brand.length) {
          filtered_brand.addClass("visible")
          // add image tags
          var logo_holder = filtered_brand.find(".logo")
          if (!logo_holder.html().length) {
            var logo = new Image()
            logo.src = filtered_brand.data("logo")
            logo_holder.append(logo)
          }

          var image_holder = filtered_brand.find(".image")
          console.log(image_holder.html().length)
          if (!image_holder.html().length) {
            var image = new Image()
            image.src = filtered_brand.data("image")
            if (image_holder.data("max-width")) {
              $(image).css("max-width", image_holder.data("max-width"))
            }
            image_holder.append(image)
          }
        } else {
          load_more_btn.addClass("hide")
        }
      }
    }

    // load more
    window.loadMoreBrands = function () {
      page_index++
      window.showFiltered()
    }

    window.showFiltered()
  }

  /**
   * Window Resize
   */
  var resize_window
  $(window).resize(function () {
    clearTimeout(resize_window)
    resize_window = setTimeout(resizeWindow, 200)
  })
  function resizeWindow() {
    var windowWidth = window.innerWidth

    // Larger than small
    if (windowWidth > 768) {
      if ($(".js-filter-menu").length) {
        $(".js-filter-menu .dropdown").removeAttr("style")
        $(".js-filter-menu span").removeClass("open")
      }
    }
  }
})
